import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './dashboard.component';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      activeLink: ToolbarButton.HOME
    },
    title: 'Dashboard',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
